"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _vue = require("vue");
var _state = _interopRequireDefault(require("@/libs/state"));
var _UserAvatarCommon = require("./UserAvatarCommon");
var _default = exports.default = {
  __name: 'UserAvatar',
  props: {
    user: {
      type: Object,
      default: null
    },
    message: {
      type: Object,
      default: null
    },
    network: {
      type: Object,
      default: null
    },
    size: {
      type: String,
      default: 'small'
    },
    forceShowStatus: {
      type: Boolean,
      default: false
    },
    allowToggle: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var state = (0, _state.default)();
    var avatarVersion = (0, _vue.ref)(0);
    var normalizarChatlatinosKey = function normalizarChatlatinosKey(value) {
      var _context;
      return (0, _trim.default)(_context = String(value || '').toLowerCase().replace(/^[@+~&%]+/, '')).call(_context);
    };
    var getNickKey = function getNickKey() {
      var _props$message, _props$user;
      return normalizarChatlatinosKey(((_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.nick) || ((_props$user = props.user) === null || _props$user === void 0 ? void 0 : _props$user.nick) || '');
    };
    var getAccountKey = function getAccountKey() {
      var _props$user2;
      return normalizarChatlatinosKey(((_props$user2 = props.user) === null || _props$user2 === void 0 ? void 0 : _props$user2.account) || '');
    };
    var getDisplayNick = function getDisplayNick() {
      var _context2, _props$message2, _props$user3, _props$user4;
      return (0, _trim.default)(_context2 = String(((_props$message2 = props.message) === null || _props$message2 === void 0 ? void 0 : _props$message2.nick) || ((_props$user3 = props.user) === null || _props$user3 === void 0 ? void 0 : _props$user3.nick) || ((_props$user4 = props.user) === null || _props$user4 === void 0 ? void 0 : _props$user4.account) || 'User').replace(/^[@+~&%]+/, '')).call(_context2) || 'User';
    };
    var getFallbackColour = function getFallbackColour(nick) {
      var colours = ['#00b894', '#0984e3', '#6c5ce7', '#e84393', '#d63031', '#e17055', '#00cec9', '#2d3436', '#27ae60', '#8e44ad', '#006266', '#1e3799', '#b71540', '#079992', '#fa983a', '#78e08f'];
      var hash = 0;
      var value = String(nick || 'User').toLowerCase();
      for (var i = 0; i < value.length; i += 1) {
        hash = (hash * 31 + value.charCodeAt(i)) % 2147483647;
      }
      return colours[hash % colours.length];
    };
    var avatarEventMatchesThisUser = function avatarEventMatchesThisUser(detail) {
      if (!detail) {
        return false;
      }
      var eventNick = normalizarChatlatinosKey(detail.nick || '');
      var eventAccount = normalizarChatlatinosKey(detail.account || '');
      var nick = getNickKey();
      var account = getAccountKey();
      if (nick && eventNick && nick === eventNick) {
        return true;
      }
      if (account && eventAccount && account === eventAccount) {
        return true;
      }
      return false;
    };
    var onGlobalAvatarUpdated = function onGlobalAvatarUpdated(event) {
      var detail = event && event.detail ? event.detail : {};
      if (!avatarEventMatchesThisUser(detail)) {
        return;
      }
      if (props.user && detail.url) {
        props.user.avatar = (0, _assign.default)({}, props.user.avatar || {}, {
          small: detail.url,
          large: detail.url
        });
      }
      avatarVersion.value += 1;
    };
    (0, _vue.onMounted)(function () {
      if (typeof window !== 'undefined') {
        window.addEventListener('chatlatinos:avatar-updated', onGlobalAvatarUpdated);
      }
    });
    (0, _vue.onBeforeUnmount)(function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('chatlatinos:avatar-updated', onGlobalAvatarUpdated);
      }
    });
    var getGlobalAvatarUrl = function getGlobalAvatarUrl() {
      if (typeof window === 'undefined' || !window.chatlatinosAvatars) {
        return '';
      }
      var globalAvatars = window.chatlatinosAvatars;
      var nick = getNickKey();
      var account = getAccountKey();
      if (typeof globalAvatars.get === 'function') {
        return globalAvatars.get(nick) || globalAvatars.get(account) || '';
      }
      if (globalAvatars.byNick && nick && globalAvatars.byNick[nick]) {
        return globalAvatars.byNick[nick];
      }
      if (globalAvatars.byAccount && account && globalAvatars.byAccount[account]) {
        return globalAvatars.byAccount[account];
      }
      return '';
    };
    var getEffectiveAvatarUrl = function getEffectiveAvatarUrl(size) {
      var globalUrl = getGlobalAvatarUrl();
      if (!props.user) {
        return globalUrl;
      }
      var userAvatar = props.user.avatar || {};
      var directUrl = userAvatar[size] || userAvatar.small || userAvatar.large || '';
      if (directUrl) {
        return directUrl;
      }
      return globalUrl;
    };
    var getSizeObj = function getSizeObj(size) {
      var avatarUrl = getEffectiveAvatarUrl(size);
      return {
        url: avatarUrl,
        vbind: {
          'href': avatarUrl,
          'xlink:href': avatarUrl
        },
        setFailed: function setFailed() {
          if (props.user && props.user.avatar) {
            var avatarData = props.user.avatar;
            var failedAvatar = avatarData[size];
            avatarData[size] = '';
            if (!avatarData.small && !avatarData.large) {
              state.$emit('user.avatar.failed', {
                user: props.user,
                network: props.network,
                failed: failedAvatar
              });
            }
          }
          avatarVersion.value += 1;
        }
      };
    };
    var shouldShowStatus = function shouldShowStatus() {
      if (!props.network || !props.user) {
        return false;
      }
      if (props.forceShowStatus) {
        return true;
      }
      if (props.network.state !== 'connected' || !state.setting('showAwayStatusIndicators')) {
        return false;
      }
      var awayNotifyEnabled = props.network.ircClient.network.cap.isEnabled('away-notify');
      return state.setting('buffers.who_loop') || awayNotifyEnabled;
    };
    var awayStatus = (0, _vue.computed)(function () {
      var show = shouldShowStatus();
      var vbind = {};
      if (show) {
        vbind.mask = 'url(#kiwi-avatar-mask)';
      }
      var transform = (0, _UserAvatarCommon.getAvatarTransform)();
      return {
        show: show,
        vbind: vbind,
        transform: transform
      };
    });
    var avatar = (0, _vue.computed)(function () {
      var currentAvatarVersion = avatarVersion.value;
      var initialsLength = state.setting('avatars.initials_length');
      if (!initialsLength || initialsLength < 1) {
        initialsLength = 1;
      }
      if (initialsLength > 2) {
        initialsLength = 2;
      }
      var nick = getDisplayNick();
      var initials = nick.substring(0, initialsLength).toUpperCase();
      var smallUrl = getEffectiveAvatarUrl('small');
      var largeUrl = getEffectiveAvatarUrl('large');
      var hasImage = !!(smallUrl || largeUrl);
      var showBackground = !hasImage || state.setting('avatars.show_image_background');
      var backgroundStyle = {};
      var avatars = {
        hasImage: hasImage,
        initials: initials,
        showBackground: showBackground,
        backgroundStyle: backgroundStyle,
        sizeKey: {},
        version: currentAvatarVersion
      };
      if (props.user && typeof props.user.getColour === 'function') {
        backgroundStyle.fill = props.user.getColour();
      } else {
        backgroundStyle.fill = getFallbackColour(nick);
      }
      if (smallUrl) {
        avatars.small = getSizeObj('small');
        avatars.sizeKey.small = 'small';
        if (!largeUrl) {
          avatars.sizeKey.large = 'small';
        }
      }
      if (largeUrl) {
        avatars.large = getSizeObj('large');
        avatars.sizeKey.large = 'large';
        if (!smallUrl) {
          avatars.sizeKey.small = 'large';
        }
      }
      return avatars;
    });
    var toggleAway = function toggleAway() {
      if (!props.allowToggle || !props.user || props.user.away === 'offline') {
        return;
      }
      var isAway = props.user.isAway();
      props.network.ircClient.raw('AWAY', isAway ? '' : 'Currently away');
    };
    return {
      __sfc: true,
      state: state,
      avatarVersion: avatarVersion,
      props: props,
      normalizarChatlatinosKey: normalizarChatlatinosKey,
      getNickKey: getNickKey,
      getAccountKey: getAccountKey,
      getDisplayNick: getDisplayNick,
      getFallbackColour: getFallbackColour,
      avatarEventMatchesThisUser: avatarEventMatchesThisUser,
      onGlobalAvatarUpdated: onGlobalAvatarUpdated,
      getGlobalAvatarUrl: getGlobalAvatarUrl,
      getEffectiveAvatarUrl: getEffectiveAvatarUrl,
      getSizeObj: getSizeObj,
      shouldShowStatus: shouldShowStatus,
      awayStatus: awayStatus,
      avatar: avatar,
      toggleAway: toggleAway
    };
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserAvatar"]
window._kiwi_exports.components.UserAvatar = exports.default ? exports.default : exports;
